import React,{useState,useEffect} from 'react';
import Header from '../../components/common/Header';
import AccountDetail from '../../components/Student/AccountDetail';
import BankTransferForm from '../../components/Student/BankTransferForm';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';

import { useNavigate,useLocation} from 'react-router-dom';
import ChecqueForm from '../../components/Student/ChecqueForm';
import PosDetailForm from '../../components/Student/PosDetailForm';
import PosDatedChecque from '../../components/Student/PosDatedChecque';
import { getOfflinePaymentTypes } from '../../actions/StudentAction';


const BankTransfer = (props) => {
    const navigate = useNavigate();
    const location=useLocation();
    const [detail,setDetail] = useState();
    const [feeDetail,setFeeDetail]=useState()
    const [transactionType, setTransactionType] = useState({ value: '', error: '',options:[], isRequired: true });
    const [payType,setPayType]=useState()

    useEffect(() => {
        sessionStorage.getItem('userDetail') ?  navigate('/bank-transfer') : navigate('/login');
        if(location&& location.state!==null){
            const {detail,feeDetail,payType}=location.state
            const userId=detail.id
            setDetail(detail)
            setFeeDetail(feeDetail)
            setPayType(payType)
        }
 
    },[location.state]);

    useEffect(async()=>{
        const paymentRes=await getOfflinePaymentTypes()

        let options=paymentRes.data.map(item=>{
            item.id==2?item.checked=true:item.checked=false
            return item
        })

        setTransactionType({...transactionType,options:options,value:2})
    },[])




  return (
     <>
      <Header detail={detail}/>
      <section className="pt-5 pb-5 content-section">
        <div className="container">
            <PageBreadcrumbs  profileDetailLink={detail} pagename="Bank Transfer" />  
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="register-box">
                        {/* <div className='allenAccountDetaiWrap border p-3 mb-4 rounded'>
                       
                            <AccountDetail detail={detail}/>
                        </div> */}
                        <div className="alert alert-warning" role="alert">
                            <b>NOTE</b> : <b>Dear Parent/Student,</b> After successfully completing the <b>(Cheque/Post Dated Cheque/POS)</b>  of Course Fee,
                                Please fill out the following transaction details.
                        </div>
                        <div className='row'>
                            <div className="col-lg-12 mb-2">
                                <div className="mandotory_field">
                                    <label className="form-check-label terms_check"  >
                                        Please choose transaction type
                                    </label>
                                </div>
                            </div>
                                   
                            <div className='col-lg-12 mb-4'>
                            <div className='d-flex flex-wrap justify-content-start mb-3 mt-2'>
            
                                    {/* <label className="form-check form-check-inline ps-0">
                                        <input type="radio" value="1" checked={transactionType.value==1}
                                            name="transactionType"  onChange={(e) => setTransactionType({ ...transactionType, value: e.target.value, error: '' })} />
                                        &nbsp;Bank Transfer
                                    </label> */}
                                    <label className="form-check form-check-inline ps-0">
                                        <input type="radio" value="2" checked={transactionType.value==2}
                                            name="transactionType" onChange={(e) => setTransactionType({ ...transactionType, value: e.target.value, error: '' })} />
                                        &nbsp;Cheque
                                    </label>
                                    <label className="form-check form-check-inline ps-0">
                                        <input type="radio" value="3"
                                            name="transactionType" onChange={(e) => setTransactionType({ ...transactionType, value: e.target.value, error: '' })} />
                                        &nbsp;Post dated cheque
                                    </label>
                                    <label className="form-check form-check-inline ps-0">
                                        <input type="radio" value="4"
                                            name="transactionType" onChange={(e) => setTransactionType({ ...transactionType, value: e.target.value, error: '' })} />
                                        &nbsp;POS
                                    </label>
                                {transactionType.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{transactionType.error}</div>}
                            </div>
                            </div>
                        </div>
                        {/* Bank transfer */}
                        {transactionType.value == 1 &&
                        <div className='bankTrasferForm_detail'>
                       {detail!==undefined && feeDetail!==undefined && payType !==undefined && 
                        <BankTransferForm  detail={detail} feeDetail={feeDetail} payType={payType} transactionType={transactionType.value} />}
                        </div>
                        }

                        {transactionType.value == 2 &&
                        <div className='checqueForm_detail'>
                        {detail!==undefined && feeDetail!==undefined && payType !==undefined && 
                        <ChecqueForm detail={detail} feeDetail={feeDetail} payType={payType}  transactionType={transactionType.value}/>}
                        {/* <ChecqueForm/> */}
                        </div>
                        }

                        {transactionType.value == 3 &&
                        <div className='posForm_detail'>
                        {detail!==undefined && feeDetail!==undefined && payType !==undefined && 
                        <PosDatedChecque detail={detail} feeDetail={feeDetail} payType={payType}  transactionType={transactionType.value}/>}
                         
                        </div>
                        }

                        {transactionType.value == 4 &&
                        <div className='posForm_detail'>
                        {detail!==undefined && feeDetail!==undefined && payType !==undefined && 
                        <PosDetailForm detail={detail} feeDetail={feeDetail} payType={payType}  transactionType={transactionType.value}/>}
                        {/* <PosDetailForm/> */}
                        </div>
                        }
                        
                    </div>
                </div>
            </div>
        </div>
        </section>
    </>
    
  )
}

export default BankTransfer
